import {
  Box, Menu, MenuItem, Button, ClickAwayListener,
} from '@mui/material';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SyntheticEvent, useRef, useState } from 'react';
import { useUserContext } from '../../contexts/UserContext';
import LogoutModal from '../logoutModal';
import { ReactComponent as PlanF } from '../../assets/img/plans/icon_plan_F.svg';
import { ReactComponent as PlanL } from '../../assets/img/plans/icon_plan_L.svg';
import { ReactComponent as PlanR } from '../../assets/img/plans/icon_plan_R.svg';
import { ReactComponent as PlanB } from '../../assets/img/plans/icon_plan_B.svg';
import { ReactComponent as PlanS } from '../../assets/img/plans/icon_plan_S.svg';

interface Props {
  name: string
  hasMenu: boolean
  hasMainPage?: boolean,
  planName: string,
  planInitial: string
}

export const MyMenu = (props: Props) => {
  const {
    name,
    hasMenu,
    hasMainPage = false,
    planName,
    planInitial,
  } = props;
  const Navigate = useNavigate();

  const [myOptionsAnchor, setMyOptionsAnchor] = useState(null);
  const myOptionsOpen = Boolean(myOptionsAnchor);

  const [logoutModalOpen, setLogoutModalOpen] = useState(false);
  const { logoutUser } = useUserContext();

  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [tooltipClicked, setTooltipClicked] = useState(false);
  const tooltipTarget = useRef(null);

  const handleMyOptionsClose = () => {
    setMyOptionsAnchor(null);
  };

  const handleAccountClicked = () => {
    handleMyOptionsClose();
    Navigate('/my-account');
  };

  const handleMyOptionsClicked = (e: SyntheticEvent) => {
    if (!hasMenu) {
      return;
    }
    setMyOptionsAnchor(e.target);
  };

  const planIcon = (() => {
    const baseTheme = {
      width: '23px',
      height: '23px',
      border: '2px solid transparent',
    };

    switch (planInitial) {
      case 'L':
        return <PlanL style={baseTheme} />;
      case 'R':
        return <PlanR style={baseTheme} />;
      case 'B':
        return <PlanB style={baseTheme} />;
      case 'S':
        return <PlanS style={baseTheme} />;
      default:
        return <PlanF style={baseTheme} />;
    }
  });

  return (
    <div className="navbar-collapse collapse">
      <ul className="navbar-nav navbar-align">
        <li className="nav-item dropdown">
          {hasMainPage ? (
            <Box>
              <Button
                onClick={handleMyOptionsClicked}
                startIcon={planIcon()}
                disableRipple
                style={{ cursor: 'default' }}
                sx={{ '&:hover': { backgroundColor: 'transparent' }, textTransform: 'none' }}
                color="inherit"
                variant="text"
              >
                {name}
              </Button>
            </Box>
          ) : (
            <ClickAwayListener onClickAway={() => setTooltipClicked(false)}>
              <Box
                onClick={() => setTooltipClicked(!tooltipClicked)}
                onMouseEnter={() => setTooltipOpen(true)}
                onMouseLeave={() => setTooltipOpen(false)}
              >
                <Button
                  ref={tooltipTarget}
                  onClick={handleMyOptionsClicked}
                  startIcon={(
                    <OverlayTrigger
                      show={tooltipOpen || tooltipClicked}
                      placement="left"
                      overlay={(
                        <Tooltip
                          id="plan-name-tooltip"
                          {...props}
                        >
                          {planName}
                        </Tooltip>
                      )}
                    >
                      {planIcon()}
                    </OverlayTrigger>
                  )}
                  endIcon={(<FontAwesomeIcon fontWeight="bold" icon={faAngleDown} style={{ fontSize: '10px' }} />)}
                  disableRipple
                  style={{ cursor: 'pointer' }}
                  sx={{ '&:hover': { backgroundColor: 'transparent' }, textTransform: 'none' }}
                >
                  {name}
                </Button>
              </Box>
            </ClickAwayListener>
          )}
          <Menu
            style={{ zIndex: 10 }}
            id="basic-menu"
            anchorEl={myOptionsAnchor}
            open={myOptionsOpen}
            onClose={handleMyOptionsClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            <MenuItem
              sx={{ height: '1.8rem', paddingLeft: 0, paddingRight: 0 }}
              onClick={handleAccountClicked}
            >
              <a className="dropdown-item" href="#">
                <i className="fa-solid fa-user-gear fa-fw" />
                {' '}
                アカウント設定
              </a>
            </MenuItem>
            <hr className="dropdown-divider my-2" />
            <MenuItem sx={{ height: '1.8rem', paddingLeft: 0, paddingRight: 0 }} onClick={() => setLogoutModalOpen(true)}>
              <a className="dropdown-item" href="#" data-bs-toggle="modal" data-bs-target="#logoutModal">
                <i className="fa-solid fa-door-open fa-fw" />
                {' '}
                ログアウト
              </a>
            </MenuItem>
            <LogoutModal
              open={logoutModalOpen}
              handleClose={() => setLogoutModalOpen(false)}
              handleSave={() => {
                logoutUser();
                setLogoutModalOpen(false);
              }}
            />
          </Menu>

        </li>
      </ul>
    </div>
  );
};
